import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, money, toMajor } from "@/lib/api";

export function useCardReturn(onPaid) {
  const [sp, setSp] = useSearchParams();
  const sid = sp.get("card_session");
  useEffect(() => {
    if (!sid) return;
    let n = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/trip-payments/${sid}`);
        if (data.payment_status === "paid") { toast.success("Payment received. Thank you!"); setSp({}); onPaid(); return; }
      } catch { return; }
      if (++n < 8) setTimeout(poll, 2000); else toast.message("Your payment is still processing. Check back in a minute.");
    };
    poll();
  }, [sid]); // eslint-disable-line react-hooks/exhaustive-deps
}

export default function CardPay({ balance, cur, feeBps, payPath }) {
  const [amt, setAmt] = useState(toMajor(balance, cur));
  const [busy, setBusy] = useState(false);
  if (!balance || balance <= 0) return null;
  const pay = async () => {
    setBusy(true);
    try { const { data } = await api.post(payPath, { amount: amt, origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="card space-y-3 p-5" data-testid="card-pay-box">
      <h3 className="flex items-center gap-2 font-bold"><CreditCard className="h-5 w-5 text-teal-600" />Pay by card</h3>
      <p className="text-xs text-slate-500">Paid securely through Stripe straight to your organizer. Remaining: {money(balance, cur)}. Triply keeps a {feeBps / 100}% service fee from the organizer's payout, not on top of your payment.</p>
      <div className="flex gap-2"><Input inputMode="decimal" value={amt} onChange={(e) => setAmt(e.target.value)} data-testid="card-pay-amount" />
        <Button className="rounded-full" onClick={pay} disabled={busy} data-testid="card-pay-button">{busy ? "Opening…" : "Pay"}</Button></div>
    </div>
  );
}
